import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Card = styled(motion.div)`
  background-color: #1E1E1E;
  border-radius: 12px;
  padding: 32px;
  color: #E0E0E0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  
  &:before {
    content: '"';
    font-family: Georgia, serif;
    font-size: 80px;
    position: absolute;
    top: -10px;
    left: 20px;
    color: rgba(33, 150, 243, 0.2); /* Electric blue with opacity */
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }
`;

const Quote = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 24px;
  font-style: italic;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

const Avatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #2196F3;
  background-image: ${props => props.src ? `url(${props.src})` : 'none'};
  background-size: cover;
  background-position: center;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* If no image is provided, show initials */
  &:empty:before {
    content: '${props => props.initials || 'U'}';
    color: white;
    font-weight: bold;
    font-size: 24px;
  }
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #FFFFFF;
`;

const CarInfo = styled.span`
  font-size: 14px;
  color: #BBB;
`;

const Savings = styled.span`
  font-size: 14px;
  color: #00C853; /* Emerald green */
  margin-top: 4px;
`;

const Testimonial = ({ 
  quote, 
  name, 
  avatar, 
  car, 
  savings,
  animationDelay = 0 
}) => {
  // Generate initials from name
  const initials = name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase();
    
  return (
    <Card
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: animationDelay }}
    >
      <Quote>"{quote}"</Quote>
      <UserInfo>
        <Avatar src={avatar} initials={initials} />
        <UserDetails>
          <Name>{name}</Name>
          {car && <CarInfo>Purchased: {car}</CarInfo>}
          {savings && <Savings>Saved: ${savings}</Savings>}
        </UserDetails>
      </UserInfo>
    </Card>
  );
};

export default Testimonial;
